import React, {useEffect} from "react";
import axios from "axios";

function SerieInfo({serieName, url}){

    useEffect(() => {
        async function fetchUserData(){
            try{
                const response = (await axios.get(`${url}?apikey=${process.env.REACT_APP_API_KEY}`));
                console.log(response.data);
            } catch(e) {
                console.error(e);
            }
        }
        fetchUserData();
    }, [])

    return(
        <p className="serierecords"><span>{serieName}</span>
        </p>
    )
}

export default SerieInfo;
